import SubcategoryPage from '@/components/template/SubcategoryPage';

const Tree = () => {
  const products = [
    {
      title: "Tree Classic",
      imageSrc: "https://images.unsplash.com/photo-1584458313453-5589fcbb6233?auto=format&fit=crop&q=80",
      url: "/proizvodi/tree-classic"
    },
    {
      title: "Tree Modern",
      imageSrc: "https://images.unsplash.com/photo-1586798532888-f52f05e261ee?auto=format&fit=crop&q=80",
      url: "/proizvodi/tree-modern"
    },
    {
      title: "Tree Premium",
      imageSrc: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?auto=format&fit=crop&q=80",
      url: "/proizvodi/tree-premium"
    },
    {
      title: "Tree Minimal",
      imageSrc: "https://images.unsplash.com/photo-1597696929736-6d13bed8e6a8?auto=format&fit=crop&q=80",
      url: "/proizvodi/tree-minimal"
    },
    {
      title: "Tree Natural",
      imageSrc: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?auto=format&fit=crop&q=80&w=1200",
      url: "/proizvodi/tree-natural"
    },
    {
      title: "Tree Elite",
      imageSrc: "https://images.unsplash.com/photo-1584458313453-5589fcbb6233?auto=format&fit=crop&q=80&w=1200",
      url: "/proizvodi/tree-elite"
    }
  ];

  return (
    <SubcategoryPage
      title="Tree"
      description="Elegantni in funkcionalni Tree obešalniki, ki dodajo naravni pridih vašemu prostoru."
      heroImage="https://images.unsplash.com/photo-1584458313453-5589fcbb6233?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default Tree;